/**
 * Restrained wizard progress — hairline track, pine fill segment.
 * @see frontend/src/design/DESIGN.md (wizard step indicator pattern)
 */
import React from 'react';

const WizardStepIndicator = ({ currentStep, totalSteps, className = '' }) => {
  const safeTotal = Math.max(1, totalSteps);
  const safeCurrent = Math.min(Math.max(1, currentStep), safeTotal);
  const pct = (safeCurrent / safeTotal) * 100;

  return (
    <div className={`mb-8 ${className}`} aria-label={`Step ${safeCurrent} of ${safeTotal}`}>
      <div className="flex justify-between text-label text-secondary mb-2">
        <span>
          Step {safeCurrent} of {safeTotal}
        </span>
      </div>
      <div className="h-1 w-full rounded-full bg-hairline overflow-hidden">
        <div
          className="h-full bg-pine rounded-full transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default WizardStepIndicator;
